import MessageFormat from "messageformat";

type Translator = (id: string, data?: any) => string;

interface TranslationData {
    translations: Record<string, string>;
    fallbacks: Record<string, string>;
    locale: string;
    defaultLocale: string;
}

function setupTranslations(): Translator {
    const data: TranslationData = JSON.parse(document.getElementById("translation-data").innerHTML);

    const userLocaleMF = new MessageFormat(data.locale);
    const userLocaleTranslations = userLocaleMF.compile(data.translations);

    const defaultLocaleMF = new MessageFormat(data.defaultLocale);
    const fallbackTranslations = defaultLocaleMF.compile(data.fallbacks);

    return (id: string, data?: any): string => {
        const userTranslation = userLocaleTranslations[id];
        if (userTranslation !== undefined) {
            return userTranslation(data);
        }

        const fallbackTranslation = fallbackTranslations[id];
        if (fallbackTranslation !== undefined) {
            return fallbackTranslation(data);
        }

        return id;
    };
}

const t = setupTranslations();

export default t;
